<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      validation-provider(name="banco" rules="required" v-slot="{ errors }")
        label ¿Dónde tienes el crédito hipotecario?
        bank-select(
          v-model="data.bank"
          name="banco"
          :error-messages="errors"
        )

      validation-provider(name="cuota actual" rules="required|min_value:400000|max_value:30000000" v-slot="{ errors }")
        label Cuota actual
        v-text-field-money(
          v-model="data.simpleFee"
          :error-messages="errors"
          name="cuota actual"
        )

      validation-provider(name="monto deuda actual" rules="required|min_value:5000000|max_value:4800000000" v-slot="{ errors }")
        label Monto de la deuda actual
        v-text-field-money(
          v-model="data.credit"
          :error-messages="errors"
          name="monto deuda actual"
        )

      validation-provider(name="meses por pagar" rules="required|numeric|min_value:60|max_value:240" v-slot="{ errors }")
        label Meses por pagar
        v-text-field(
          v-model.number="data.months"
          :error-messages="errors"
          name="meses por pagar"
          type="number"
        )
</template>

<script>
  import formMixin from '@/mixins/form-mixin';

  import BankSelect from '@/components/inputs/bank-select';

  const DEFAULT_VALUES = {
    bank: null,
    simpleFee: null,
    months: null,
    credit: null,
  };

  export default {
    name: 'mortgage-form',

    mixins: [
      formMixin(),
    ],

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },

    components: {
      BankSelect,
    },
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0
</style>